<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M36.05 13H32v-.72A8.18 8.18 0 0024.55 4 8 8 0 0016 12v1h-4a2 2 0 00-2 1.79l-2.89 27a2 2 0 002 2.21h29.83a2 2 0 002-2.21l-2.94-27A2 2 0 0036.05 13zM19 12a5 5 0 0110 0v1H19zm-8.83 29l2.68-25H16v2.5a1.5 1.5 0 003 0V16h10v2.5a1.5 1.5 0 003 0V16h3.15l2.68 25z"/></svg>